<template>
	<div class="bottom-charts">
		<Chart :cdata="cdata" :width="'652'" :height="'382'" />
	</div>
</template>

<script>
	import Chart from './chart.vue'
	// import MyTitle from '@/views/components/MyTitle.vue';
	import {
		dataInterface
	} from "@/api/dataInterfaceApi"
	import * as echarts from 'echarts5'
	export default {
		components: {
			// MyTitle,
			Chart,
		},
		data() {
			return {
				cdata: {
					
					category: [

					],
					rateData: [],
					id: "carAddChart",
					legendData: [{
						name: "功率曲线",
						icon: 'roundRect',
					}],
					yAxis: {
						name:'kW',
						nameTextStyle: {
						fontSize:20,
					    },
						axisLine:{     //x轴坐标轴，false为隐藏，true为显示
							"show":false
						},
						axisLabel: {
						  formatter: "{value} ",
						  textStyle: {
							color: "rgba(255, 255, 255, 0.65)",
							fontSize:20
						  }
					    },  
				    },
				series: [{
					name: "功率曲线",
					type: "line",
					smooth: true,
					symbolSize: 1,
					// yAxisIndex: 1,
					itemStyle: {
						color: "#60E5E7"
					},
					data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
					// lineStyle: {
					// 	color: '#f9ce60'
					// },
					areaStyle: {
						opacity: 0.8,
						color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#89D2D3'
							},
							{
								offset: 1,
								color: '#19303C'
							}
						])
					},
				}, ],
				// yAxisname: 'kW'
			}
			// show2: false,
			// batteryChargingData2: {}
		}
	},
	destroyed() {
			this.$bus.$off("updateTankuang");
		},
		mounted() {
			this.$bus.$on("updateTankuang", () => {
				this.getData();
			});
			this.getData();
		},

		methods: {
			getData() {
				let params = {
					"enCode": 'powerplant-right-cdcsszglqx',
					// "@station_id": localStorage.getItem("dummySattionId") ? localStorage.getItem("dummySattionId") :
					// 	'e82949e18d0b4c7abb8184d5d259ba7d'
					"@station_id": '14741a1d1ec94ae8a32e503d5cc5c3a6'
				}
				dataInterface
					.dataFaceApi(params)
					.then((res) => {
						console.log("功率", res,params)
						if (!res) return;
						let cpow = [];
						let xList = [];
						res.map(item => {
							cpow.push(item.cpow);
							xList.push(item.time_window);
							// console.log(item.time_window.slice(11), 'item.time_window.slice(1,1)')
						})
						this.cdata.category = xList; //
						this.cdata.series[0].data = cpow;
						// console.log(cpow,'cpow')
						// this.cdata.series[1].data = regulate_efficiency_xy;
					})
					.catch((err) => {
						console.log(err);
					});
			}
		}
	}
</script>

<style lang="scss" scoped>
	/* @import "./comm.scss"; */
	.bottom-charts {
		margin-top: 15px;
		padding-left: 30px;
		font-size: 24px;
		// background-color: green;
	}
</style>